
import  request  from '../../Interceptor/request.js'

//额外费用记录搜索
export function costList(query) {
    return request({
        url: '/costRecord/list',
        method: 'get',
        params:query
    })
}

// 生成订单编号
export function billOrderNo(data){
    return request({
        url:'/order',
        method: 'post',
        data
    })
}

//额外费用搜索
export function costTypeList() {
    return request({
        url: '/costType/list',
        method: 'get'
    })
}